import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Menu, MenuItem } from "@mui/material";
import { MprcButtonProps } from "components/MprcButton";
import * as React from "react";

export interface IMenuItem {
    text: React.ReactNode;
    value: any;
    appendSeparator?: boolean;
}

interface IProps {
    text?: string;
    button: React.FC<MprcButtonProps>;
    buttonColor?: MprcColors;
    items: Array<IMenuItem>;
    onChange: (selectedValue: any) => void;
}

interface IMenuState {
    anchor: Element | null;
}

export const MprcButtonDropdown: React.FC<IProps> = (props) => {

    const { button: Button, items, text, buttonColor, onChange } = props;

    const [state, setState] = React.useState<IMenuState>({
        anchor: null
    });

    const menuItems = React.useMemo(() => {
        var arr: React.ReactNode[] = [];
        items.forEach((v, index) => {
            arr.push(
                <MenuItem
                    key={index}
                    onClick={() => { setState({ anchor: null }); onChange(v.value); }}
                >
                    {v.text}
                </MenuItem>
            );

            if (v.appendSeparator) {
                arr.push(<Box sx={{ mt: 1.5 }} key={`${index}_blank`} />);
            }
        });
        return arr;
    }, [items]);


    return (
        <>
            <Button
                text={text}
                color={buttonColor ?? "inherit"}
                onClick={(e) => setState({ anchor: e.currentTarget })}
                endIcon={<KeyboardArrowDownIcon />}
            />

            <Menu
                anchorEl={state.anchor}
                open={state.anchor != null}
                onClose={
                    () => {
                        setState({ anchor: null });
                    }
                }
            >
                {menuItems}
            </Menu>
        </>
    );
};
